type FrenchMapping = {
  [key: string]: string
}

const frenchMapping: FrenchMapping = {
  '5G': '5G',
  'Team Members': 'Membres de l’équipe',
  Technology: 'Technologie',
  'Community support & charitable funding': 'Soutien communautaire et financement caritatif',
  'Connecting rural Canada': 'Connecter les régions rurales du pays',
  'Community aid': 'Aide communautaire',
  Partnerships: 'Partenariats',
  'TELUS Friendly Future Foundation': 'Fondation TELUS pour un futur meilleur',
  'Mobility for Good': 'Mobilité pour l’avenir',
  'Internet for Good': 'Internet pour l’avenir',
  'Tech for Good': 'Technologies pour l’avenir',
  'For Good Programs': 'Programmes Connectés pour l’avenir',
  'Health for Good': 'Santé pour l’avenir',
  Indigenous: 'Autochtones',
  Innovation: 'Innovation',
  'Youth & education': 'Jeunes et éducation',
  'Mental health': 'Santé mentale',
  'Charitable support & funding': 'Soutien et financement caritatifs',
}

export default frenchMapping
